import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            alignItems: 'center',
            flexDirection: 'column',
            gap: {base: remCalc(25)},
            justifyContent: 'flex-start',
            mx: 'auto',
            py: {base: remCalc(40)},
            px: {base: remCalc(16), md: remCalc(40)},
        },
        label: {
            my: {base: remCalc(-4), md: remCalc(-5)},
            color: 'foreground.neutral.subtle',
            textStyle: 'body-xsmall',
            fontWeight: 'regular',
        },
        buttonAdditional: {
            flex: '0 0 auto',
            px: {base: remCalc(24)},
            width: 'auto',
        },
    },
    parts: ['container', 'label', 'buttonAdditional'],
}
